//
import campusVirtualMachine from "./machine"
import { actionsNoCare } from "../../constants/actionsNoCare"
export const { initialState } = campusVirtualMachine

const CampusVirtual = (state = initialState, action) => {
  //
  if (
    !actionsNoCare.includes(action.type) &&
    !action.type.startsWith("@@") &&
    action.type.startsWith("campusvirtual/")
  ) {
    if (!campusVirtualMachine.states[state.value]?.on?.[action.type]) {
      console.error(
        `campusVirtualMachine: No hay transición definida para la acción ${action.type} en el estado ${state.value}`
      )
    } else {
      return campusVirtualMachine.transition(state, action)
    }
  }
  return state
}

export default CampusVirtual
